// ============================================================================
// FSA ADJUSTMENT JOURNAL ENDPOINTS  (FSA-2.2 Adjustments)
// ============================================================================

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from '../base.endpoints';
import type { ID } from '../../types';
import type { AdjustmentJournalQueryParameters } from '../../types/fsa/adjustmentJournal.types';

const BASE_PATH = '/FsaAdjustmentJournals';

export const fsaAdjustmentJournalEndpoints = {
  /** GET /api/v1/FsaAdjustmentJournals/{id} */
  get: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/FsaAdjustmentJournals/by-engagement/{engId}?page=… */
  listByEngagement: (engId: ID, query?: AdjustmentJournalQueryParameters) =>
    buildEndpointWithQuery(`${BASE_PATH}/by-engagement/${engId}`, query ?? {}),

  /** GET /api/v1/FsaAdjustmentJournals/by-engagement/{engId}/audited-balances */
  auditedBalances: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/audited-balances`, { engId }),

  /** GET /api/v1/FsaAdjustmentJournals/by-engagement/{engId}/pdf?mode=... */
  bundlePdf: (engId: ID, mode: 'working-papers' | 'client-schedule') =>
    buildEndpointWithQuery(`${BASE_PATH}/by-engagement/${engId}/pdf`, { mode }),

  /** POST /api/v1/FsaAdjustmentJournals */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /api/v1/FsaAdjustmentJournals/{id} */
  update: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/FsaAdjustmentJournals/{id}?rowVersion=… */
  remove: (id: ID, rowVersion: number) =>
    buildEndpointWithQuery(`${BASE_PATH}/${id}`, { rowVersion }),

  /** POST /api/v1/FsaAdjustmentJournals/{id}/post */
  post: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/post`, { id }),

  /** POST /api/v1/FsaAdjustmentJournals/{id}/reverse */
  reverse: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/reverse`, { id }),
} as const;

export default fsaAdjustmentJournalEndpoints;
